import React from "react";
import "./Benefits.scss";

import benefitImg1 from "../../../assets/images/10057 1.png";
import benefitImg3 from "../../../assets/images/39925 1.png";

import BenefitCard from "./BenefitCard/BenefitCard";

const Benefits = () => {
  return (
    <div className="Benefits-main-container">
      <div className="Benefits-container">
        <h3>Benefits</h3>
        <h5 className="pt-2">
          The Transformative Benefits of AI-Powered Data Analytics for Brand
          Comparison
        </h5>
      </div>
      <div className="benefits-inner-container">
        <BenefitCard
          img={benefitImg1}
          heading="Enhanced Customer Experience"
          para="Aliquam convallis lacus elit, eget sodales ex lacinia at enimens ken eros mauris."
        />
        <BenefitCard
          img={benefitImg1}
          heading="Competitive Advantage"
          para="Aliquam convallis lacus elit, eget sodales ex lacinia at enimens ken eros mauris."
        />
        <BenefitCard
          img={benefitImg3}
          heading="Improved Marketing Strategies"
          para="Aliquam convallis lacus elit, eget sodales ex lacinia at enimens ken eros mauris."
        />
      </div>
      <div className="d-flex justify-content-center mt-5">
        <a href="/seemore">
          {" "}
          <button class="theme-Btn-bg mt-3">
            <span>See More</span>
          </button>
        </a>
      </div>
    </div>
  );
};

export default Benefits;
